<template>
  <div class="Home">
    <div class="pageWrap">
      <div class="video-banner">
        <div class="vimeo-wrapper wow fadeIn" data-wow-duration="1.2s" style="visibility: visible; animation-duration: 1.2s; animation-name: fadeIn;">
          <iframe src="https://player.vimeo.com/video/641979205?muted=1&amp;loop=1&amp;autoplay=1&amp;controls=0" frameborder="0" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen=""></iframe>
            <div class="outerArrow">
              <div class="downArrow bounce">
                  <i @click="handleClick()" class="fa-solid fa-chevron-down arrowHead"></i>
              </div>
            </div>
        </div> 
      </div>
      <div class="highEndAnimation">
        <h2 class="">HIGH END VISUALS AND ANIMATION</h2>
        <div class="rotating-text">
          <h2 class="rotatingText-adjective colourWhite">PHOTOREALISTIC ARCHITECTURAL VISUALISATION AND RENDERING</h2>
          <h2 class="rotatingText-adjective colourWhite">3D WALKTHROUGHS</h2>
          <h2 class="rotatingText-adjective colourWhite">VIRTUAL REALITY</h2>
          <h2 class="rotatingText-adjective colourWhite">3D Floor Plans</h2>
          <h2 class="rotatingText-adjective colourWhite">Watercolours</h2>
          <h2 class="rotatingText-adjective colourWhite">3D Models</h2>
        </div>
      </div>
      <!-- <div class="outterBlock">
        <div class="Home_text_block container">
          <h2 class="lineOne">{{acf.acf.header_1}}</h2>
          <h2 class="lineTwo">{{acf.acf.header_2}}</h2>
          <h2 class="lineThree">{{acf.acf.header_3}}</h2>
        </div>
      </div> -->
    </div>
    <div class="componentHome_block" ref="targetRef">
      <div id="skills" class="skillsBlock">
        <Skills />
      </div>
      <div id="about">
        <About />
      </div>
      <div id="blog" class="skillsBlock">
        <Blogs />
      </div>
      <div id="contact">
        <Contact />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import About from '@/components/About.vue'
import Contact from '@/components/Contact.vue'
import Skills from '@/components/Skills.vue'
import Blogs from '@/components/Blog.vue'
export default {
  name: 'Home',
  components: {
    About,
    Contact,
    Skills,
    Blogs,
  },
  data: function() {
    return {
      acf: [],
      ref: null
    };
  },
  methods: {
    isMobile() {
        if( screen.width <= 500 ) {
            return true;
        }
        else {
            return false;
        }
    },
    handleClick: function() {
      console.log('HandleClick')
      this.$refs.targetRef.scrollIntoView({ behavior: 'smooth' });
    }
  },
  mounted() {
    axios //add API Call
        .get(
            process.env.VUE_APP_API_URL + "ocs-studios/wp-json/wp/v2/pages/6"
        ) // Page number changed on each page based on JSON page id you are calling
        .then((response) => (
            this.acf = response.data
        )); //API data wanted pulled out
  },
}
</script>

<style scoped>
.outerArrow {
  z-index: 9999;
  position: relative;
}
a.colourWhiteArrow {
  color: #fff;
}
/* .Home{
  scroll-behavior: smooth;
} */
i.arrowHead {
  font-size: 60pt;
  z-index: 9999;
}
h2.wisteria {
  color: #8e44ad;
}
h2.belize {
  color: #2980b9;
}
h2.pomegranate {
  color: #c0392b;
}
h2.green {
  color: #16a085;
}
h2.midnight {
  color: #2c3e50;
}
.rotatingText {
  align-items: center;
  display: flex;
  height: 100vh;
  text-align: center;
}
.rotatingText-content {
  position: relative;
  width: 100%;
}
.rotatingText-description {
  font-family: "Georgia", serif;
  font-style: italic;
  font-size: 14px;
  margin: 0;
}
@media (min-width: 768px) {
  .rotatingText-description {
    font-size: 18px;
  }
}
.rotatingText-adjective {
  font-family: "Open Sans", sans-serif;
  font-size: 40px;
  left: 0;
  margin-bottom: 0;
  margin-top: 30px;
  opacity: 0;
  position: absolute;
  right: 0;
  text-align: center;
  text-transform: uppercase;
  top: 60px;
}
@media (min-width: 768px) {
  .rotatingText-adjective {
    font-size: 50px;
  }
}
.rotatingText-adjective:nth-of-type(1) {
  animation: rotate-text-up 1.5s 0.75s;
}
.rotatingText-adjective:nth-of-type(2) {
  animation: rotate-text-up 1.5s 2s;
}
.rotatingText-adjective:nth-of-type(3) {
  animation: rotate-text-up 1.5s 3.25s;
}
.rotatingText-adjective:nth-of-type(4) {
  animation: rotate-text-up 1.5s 4.50s;
}
.rotatingText-adjective:nth-of-type(5) {
  animation: rotate-text-up 1.5s 5.75s;
}
.rotatingText-adjective:nth-of-type(6) {
  animation: fade-text-in 1.5s 7s forwards;
}
/* .rotatingText-adjective:nth-of-type(4) {
  animation: rotate-text-up 1.5s 3.50s forwards;
}
.rotatingText-adjective:nth-of-type(5) {
  animation: rotate-text-up 1.5s 3.75s forwards;
}
.rotatingText-adjective:nth-of-type(6) {
  animation: rotate-text-up 1.5s 4s forwards;
} */
@keyframes rotate-text-up {
  0% {
      transform: translate3d(0, 80px, 0);
      opacity: 0;
  }
  20%, 80% {
      transform: translate3d(0, 0, 0);
      opacity: 1;
  }
  100% {
      transform: translate3d(0, -40px, 0);
      opacity: 0;
  }
}
@keyframes fade-text-in {
  0% {
        opacity: 0;
        transform: translate3d(0, 80px, 0);
  }
    50%, 100% {
        opacity: 1;
        transform: translate3d(0, 0, 0);
  }
}
.twitter {
  bottom: 0;
  position: fixed;
  right: 0;
  width: 50px;
}
 
.downArrow{
  position: absolute;
  bottom: 50px;
  left: 0;
  right: 0;
  z-index: 9999;
}
.bounce {
	-moz-animation: bounce 3s infinite;
	-webkit-animation: bounce 3s infinite;
	animation: bounce 3s infinite;
}
@-moz-keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    -moz-transform: translateY(0);
    transform: translateY(0);
  }
  40% {
    -moz-transform: translateY(-30px);
    transform: translateY(-30px);
  }
  60% {
    -moz-transform: translateY(-15px);
    transform: translateY(-15px);
  }
}
@-webkit-keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  40% {
    -webkit-transform: translateY(-30px);
    transform: translateY(-30px);
  }
  60% {
    -webkit-transform: translateY(-15px);
    transform: translateY(-15px);
  }
}
@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    -moz-transform: translateY(0);
    -ms-transform: translateY(0);
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  40% {
    -moz-transform: translateY(-30px);
    -ms-transform: translateY(-30px);
    -webkit-transform: translateY(-30px);
    transform: translateY(-30px);
  }
  60% {
    -moz-transform: translateY(-15px);
    -ms-transform: translateY(-15px);
    -webkit-transform: translateY(-15px);
    transform: translateY(-15px);
  }
}
/* Demo Purpose Only*/
.demo {
  font-family: 'Raleway', sans-serif;
	color:#fff;
  display: block;
  margin: 0 auto;
  padding: 15px 0;
  text-align: center;
}
.demo a{
  font-family: 'Raleway', sans-serif;
  color: #2ecc71;		
}
.text {
  position: absolute;
  width: 450px;
  left: 50%;
  margin-left: -225px;
  height: 40px;
  top: 50%;
  margin-top: -20px;
}

p {
  display: inline-block;
  vertical-align: top;
  margin: 0;
}

.highEndAnimation {
  position: absolute;
  top: 30em;
  bottom: 0;
  left: 0;
  right: 0;
}
.wisteria {
  color: #8e44ad;
}
.belize {
  color: #2980b9;
}
.pomegranate {
  color: #c0392b;
}
.green {
  color: #16a085;
}
.midnight {
  color: #2c3e50;
}
.highEndAnimation > h2 {
  font-size: 45pt;
}
.skillsBlock {
  margin-top: -10em;
}
::v-deep .btn-danger {
  color: #fff;
  background-color: #7ebd63;
  border-color: #7ebd63!important;
}
.video-banner {
  width: 100%;
  background-size: 100% auto!important;
  background-repeat: no-repeat!important;
  /* height: 37vw;
  max-height: 800px; */
  background-position: 50% 50%!important;
  overflow: hidden;
}
.vimeo-wrapper {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  pointer-events: none;
  overflow: hidden;
}
.vimeo-wrapper iframe {
  top: 25%;
}
.vimeo-wrapper iframe {
  width: 100vw;
  height: 70.25vw;
  min-height: 179vh;
  min-width: 307.77vh;
  position: absolute;
  top: 15%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.video-title-wrap {
  display: flex;
  justify-content: center;
  position: absolute;
  height: 56.25%;
  width: 100%;
}
.video-overlay {
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5));
}
.vimeo-wrapper {
  position: relative;
  /* padding-bottom: 56.25%; */
  padding-bottom: 60.25%;
  padding-top: 0;
  height: 0;
}
.HomeTopContent {
  position: absolute;
  top: 40%;
}
#myVideo {
  /* position: fixed; */
  right: 0;
  bottom: 0;
  /* min-width: 100%; */
  width: 100%;
  min-height: 100%;
}
.componentHome_block {
  display: block;
  /* margin-top: 100px; */
}
.outerImageComp {
  text-align: right;
  margin-top: -200px;
}
.computerImage {
  /* width: 100%; */
}
#skills {
  scroll-behavior: smooth;
  background: #010322;
}
.Home_text_block {
  text-align: left;
  /* margin-left: -12px; */
  /* opacity: 0.75; */
  /* margin-top: 170px; */
  /* margin-top: -96px; */
  z-index: 9999;
  position: relative;
  top: -28em;
}
.lineOne {
  font-size: 49px;
  font-weight: 400;
  color: #efd170;
  text-transform: uppercase;
  background: #000322;
  display: inline;
  padding: 10px;
  position: relative;
}
.lineTwo {
  font-size: 49px;
  font-weight: 400;
  color: #fff; 
  text-transform: uppercase;
  background: #000322;
  margin-bottom: 0px;
  padding: 10px;
  position: relative;  /* display: inline; */
  width: 321px;
}
.lineThree {
  font-size: 49px;
  font-weight: 400;
  color: #7ebd63;
  text-transform: uppercase;
  background: #000322;
  display: inline;
  padding: 10px;
  position: relative;
}
.TopHomeback-Image {
  /* background-image: url('https://wp-ocssport.ocs-sport.com/ocs-studios/wp-content/uploads/sites/2/2023/03/backgroundHome.png'); */
  background-repeat: no-repeat;
  background-size: 100% 100%;
  /* height: 100vh; */
  height: 35vh;
  /* background-color: #000322; */
  padding-bottom: 50px;
  padding-top: 50px;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
/* @media only screen and (max-width: 1650px) and (min-width :1352px) {
  .TopHomeback-Image {
    background-image: url('https://wp-ocssport.ocs-sport.com/ocs-studios/wp-content/uploads/sites/2/2023/03/HeaderImage_OCS_Studios.png');
    background-repeat: no-repeat;
    background-size: cover;
    height: 87vh;
  }
}

@media only screen and (max-width: 1352px) {
  .TopHomeback-Image {
    background-image: url('https://wp-ocssport.ocs-sport.com/ocs-studios/wp-content/uploads/sites/2/2023/03/HeaderImage_OCS_Studios.png');
    background-repeat: no-repeat;
    background-size: contain;
    height: 75vh;
  }
} */

@media only screen and (max-width: 1400px) {
  .Home_text_block {
    text-align: left;
    z-index: 9999;
    position: relative;
    top: -19em;
  }
}
@media only screen and (max-width: 1200px) {
  .outerImageComp {
    display: none;
  }
  .componentHome_block {
    display: block;
    margin-top: 0px;
  }
}
/* @media only screen and (max-width: 1030px) {

} */
@media only screen and (max-width: 1028px) {
  .lineOne {
    font-size: 30px;
  }
  .lineTwo {
    font-size: 30px;
    width: 200px;
  }
  .lineThree {
    font-size: 30px;
  }
  .Home_text_block {
    text-align: left;
    margin-top: 80px;
  }
}

@media only screen and (max-width: 500px) {
  .video-banner {
    width: 100%;
    background-size: 100% auto!important;
    background-repeat: no-repeat!important;
    height: 100vw;
    max-height: 800px;
    background-position: 50% 50%!important;
    overflow: hidden;
  }
  .vimeo-wrapper {
    position: relative;
    padding-bottom: 100%;
    padding-top: 0;
    height: 0;
  }
  .Home_text_block {
    text-align: left;
    margin-left: 0px;
  }
  #myVideo {
    display: none;
  }
  .TopHomeback-Image {
    position: absolute;
    top: 110px;
    /* background-image: url('https://wp-ocssport.ocs-sport.com/ocs-studios/wp-content/uploads/sites/2/2023/03/backgroundHome.png'); */
    /* background-repeat: no-repeat;
    background-size: 100% 100%; */
    /* height: 100vh; */
    /* height: 70vh; */
    /* background-color: #000322; */
    /* padding-bottom: 50px;
    padding-top: 50px; */
  }
  .outerImageComp {
    display: block;
    margin-top: 0px!important;
    text-align: start!important;
  }
  .computerImage {
    width: 100%;
  }
}
@media only screen and (max-width: 375px) {
  .lineOne {
    font-size: 25px;
  }
  .lineTwo {
    font-size: 25px;
    width: 340px;
  }
  .lineThree {
    font-size: 25px;
  }
}
</style>
